"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const Cell_1 = require("../components/Cell");
const Row_1 = require("../components/Row");
const useSchedule_1 = require("../useSchedule");
const Body = (0, styled_1.default)(elements_1.Flex)({
    background: constants_1.Color.BACKGROUND_GREY,
    height: constants_1.theme.spacing[2],
    width: '100%',
});
const Divider = () => {
    const { columnCount } = (0, useSchedule_1.useSchedule)();
    return ((0, jsx_runtime_1.jsx)(Row_1.Row, { children: (0, jsx_runtime_1.jsx)(Cell_1.Cell, { style: { padding: 0, height: 0 }, colSpan: columnCount, isTitle: true, children: (0, jsx_runtime_1.jsx)(Body, {}) }) }));
};
exports.Divider = Divider;
